<script setup lang="ts">
import HeaderArea from '@/components/Header/HeaderArea.vue'
import SidebarArea from '@/components/Sidebar/SidebarArea.vue'
import { useSensorStore } from '@/store/sensor'
import { useSessionStore } from '@/store/session'
import { storeToRefs } from 'pinia'
import { onMounted, onUnmounted, watchEffect } from 'vue'
import { useRouter } from 'vue-router'

const { hasSession, hasArtificialIntelligence } = storeToRefs(useSessionStore())
const router = useRouter()

watchEffect(() => {
  if (!hasSession.value) {
    router.push({ name: 'login' })
  }
})

const sensorStore = useSensorStore()
const { isSidebarOpen, selectedSensor } = storeToRefs(sensorStore)
const { closeSidebar } = sensorStore

// Adicionando controle de zoom
onMounted(() => {
  // Configura meta tag para desativar zoom
  document.querySelector('meta[name="viewport"]')?.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no')
})

onUnmounted(() => {
  // Restaura meta tag padrão quando componente for desmontado
  document.querySelector('meta[name="viewport"]')?.setAttribute('content', 'width=device-width, initial-scale=1.0')
})
</script>

<template>
  <div class="flex h-screen overflow-hidden">
    <SidebarArea v-if="hasSession" />
    <div class="relative flex flex-1 flex-col overflow-y-auto overflow-x-hidden">
      <HeaderArea v-if="hasSession" />
      <main>
        <div class="w-full mx-auto p-1 md:p-1.5">
          <slot></slot>
        </div>
      </main>
    </div>
  </div>
</template>

<style scoped>
/* Previne gestos de zoom */
div {
  touch-action: manipulation;
}
</style>
